export const FETCH_TAXSUMMARY_BEGIN="FETCH_TAXSUMMARY_BEGIN";
export const FETCH_TAXSUMMARY_SUCCESS="FETCH_TAXSUMMARY_SUCCESS";
export const FETCH_TAXSUMMARY_FAILURE="FETCH_TAXSUMMARY_FAILURE";
